import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { func, bool } from 'prop-types';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { TARGETS as orderTargets } from '~redux/Order/constants';
import { DATA_TEST_ID } from '~constants/tests';
import { subsidiaryPropTypes } from '~propTypes/subsidiary';
import { getStoreMap } from '~utils/maps';
import Text from '~components/Text';

import { MAX_CHARACTERS_TO_SHOW_TOOLTIP } from './constants';
import styles from './styles.module.scss';

const Store = ({ onSelect, store, onMouseEnter, onMouseLeave, focused }) => {
  const handleSelect = () => {
    onSelect(store);
  };

  const handleMouseEnter = () => {
    onMouseEnter(store);
  };

  const handleMouseLeave = () => {
    onMouseLeave(store);
  };

  const futureOrder = useSelector((state) => state.order[orderTargets.FUTURE_ORDER]);

  const waitTime = store.pickUpWaitTime;

  return (
    <button
      data-testid={DATA_TEST_ID.pickupStoreButton}
      type="button"
      onClick={handleSelect}
      key={store.id}
      className={cn(
        'column m-bottom-2 stretch full-width',
        styles.card,
        futureOrder && styles.cardFutureOrders,
        {
          [styles.current]: focused
        }
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <div className={`row full-width middle ${styles.storeInfo}`}>
        <div className={`column start ${styles.infoTexts} full-width`}>
          <Text className={`text-base text-dusty-gray full-width ${styles.storeName}`}>{store.name}</Text>
          {store.textAddress?.length > MAX_CHARACTERS_TO_SHOW_TOOLTIP ? (
            <>
              <p data-tip={store.textAddress}>
                <Text className={`text-base text-dusty-gray full-width ${styles.storeAddress}`}>
                  {store.textAddress}
                </Text>
              </p>
              <ReactTooltip place="top" type="dark" effect="float" />
            </>
          ) : (
            <div className="row middle m-bottom-1">
              <Text className={`text-base text-dusty-gray full-width ${styles.storeAddress}`}>
                {store.textAddress}
              </Text>
            </div>
          )}
          {!futureOrder && (
            <div className={`row middle ${styles.timeContainer}`}>
              <div className="column">
                <span className="row middle text-base text-emperor">
                  <i className={`icon-time m-right-2 ${styles.waitTimeIcon}`} />
                  <Text className={`${styles.time} text-thundora`}>
                    {i18next.t('DeliveryOrPickUp:minAprox', { waitTime })}
                  </Text>
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="row end">
          <a
            className={`column middle link full-width ${styles.mapLink}`}
            href={getStoreMap(store)}
            target="blank">
            <i className={`icon-location2 m-bottom-1 ${styles.cardIcon}`} />
            <Text className={`full-width ${styles.linkText}`}>{i18next.t('DeliveryOrPickUp:seeMap')}</Text>
          </a>
        </div>
      </div>
    </button>
  );
};

Store.propTypes = {
  store: subsidiaryPropTypes.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  onSelect: func.isRequired,
  focused: bool
};

export default Store;
